import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/rides/admin`,
});

export async function getAllRideByAdmin(payload) {
  try {
    const res = await API.post("/get-all-rides", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✅ Log the outcome of the post-ride follow-up call (reached safely?,
// app useful?, any issue with the driver?, driver brought them back safe?)
export async function updateRideFollowUpCall(payload) {
  try {
    const res = await API.post("/follow-up-call", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ════════════════════════════════════════════════════════════════════════════
// PATCH — add this export to your EXISTING admin-frontend/api/rideApi.js
// (you didn't upload rideApi.js, so this is a snippet to add, not a full file)
// It follows the same pattern as your existing updateRideFollowUpCall — same
// axios instance / base URL / auth header this file already uses.
// ════════════════════════════════════════════════════════════════════════════

// POST /api/rides/admin/confirm-trip-completed
// payload: { rideId, paymentMode: "cash" | "wallet" }
export async function adminConfirmTripCompleted(payload) {
  try {
    const res = await API.post("/confirm-trip-completed", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
